import React from 'react';
const CART_URL = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
const BG_IMAGE = 'https://cdn.magicpatterns.com/uploads/hhuWwQcHTsEccqqhqnApdN/hero-terapeuta-nino-tea.webp';
export function HeroSection() {
  return <section className="relative text-brand-ink py-16 px-6 text-center" data-id="element-82">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat overflow-hidden" style={{
      backgroundImage: `url(${BG_IMAGE})`
    }} data-id="element-83" />
      {/* White overlay — 55% to let the image show strongly */}
      <div className="absolute inset-0 bg-white/[0.55] overflow-hidden" data-id="element-84" />

      <div className="relative max-w-4xl mx-auto" data-id="element-85">
        {/* Eyebrow */}
        <div className="animate-fade-up" data-id="element-86">
          <span className="inline-block bg-brand-green text-white font-display font-extrabold tracking-[0.12em] uppercase px-5 py-1.5 rounded-sm mb-6 shadow-sm text-[18px]" data-id="element-87">
            · Acceso Inmediato
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-display font-black uppercase leading-[0.95] mb-6 animate-fade-up-delay-1" style={{
        textShadow: '0 2px 12px rgba(255,255,255,0.8), 0 0px 4px rgba(255,255,255,0.9)'
      }} data-id="element-88">
          <span className="text-brand-green block mb-4 leading-[1]" data-id="element-89">
            <span className="hidden sm:block text-6xl md:text-8xl lg:text-9xl" data-id="element-90">
              CÓDIGO SENSORIAL TEA
            </span>
            <span className="block sm:hidden" data-id="element-91">
              <span className="block tracking-tight text-[64px]" data-id="element-92">CÓDIGO</span>
              <span className="block tracking-tight text-[64px]" data-id="element-93">
                SENSORIAL
              </span>
              <span className="block tracking-tight text-[64px]" data-id="element-94">TEA </span>
            </span>
          </span>
          <span className="text-brand-ink text-2xl md:text-4xl lg:text-5xl block mt-4 leading-snug max-w-3xl mx-auto" style={{
          textShadow: '0 0 20px rgba(255,255,255,0.95), 0 0 40px rgba(255,255,255,0.7), 0 0 60px rgba(255,255,255,0.4), 0 2px 4px rgba(0,0,0,0.08)'
        }} data-id="element-95">
            EL SISTEMA CLÍNICO ESTRUCTURADO QUE ORGANIZA LA INTERVENCIÓN
            SENSORIAL Y{' '}
            <span className="text-brand-green-dark" data-id="element-96">
              ELIMINA LA IMPROVISACIÓN
            </span>{' '}
            DESDE EL PRIMER DÍA.
          </span>
        </h1>

        {/* Subtitle */}
        <p className="font-body text-brand-ink max-w-2xl mx-auto text-xl md:text-2xl mb-9 font-bold animate-fade-up-delay-2" style={{
        textShadow: '0 1px 8px rgba(255,255,255,0.95)'
      }} data-id="element-97">
          40 herramientas estructuradas + Gradación por Perfil Sensorial +
          Aplicación en 3 Contextos.
        </p>

        {/* CTA Button */}
        <div className="animate-fade-up-delay-3" data-id="element-98">
          <a href="#features-section" className="inline-block bg-brand-yellow text-brand-ink font-display font-black md:text-2xl uppercase tracking-wider py-5 rounded animate-pulse-btn hover:bg-brand-yellow-dark hover:scale-105 transition-all duration-150 shadow-lg text-[28px] px-[38px] text-center" data-id="element-99">
            QUIERO IMPLEMENTAR EL MÉTODO →
          </a>

          <span className="block text-gray-700 text-sm mt-4 font-bold tracking-wide" style={{
          textShadow: '0 1px 6px rgba(255,255,255,0.9)'
        }} data-id="element-100">
            PDF Digital · Acceso en menos de 5 minutos · Pago único
          </span>
        </div>

        {/* Trust Row */}
        <div className="flex justify-center gap-7 flex-wrap mt-9" data-id="element-101">
          {[{
          icon: '🔒',
          text: 'Pago 100% Seguro'
        }, {
          icon: '✅',
          text: 'Garantía 60 Días'
        }, {
          icon: '⚡',
          text: 'Acceso Inmediato'
        }, {
          icon: '🎁',
          text: '6 Bonos Incluidos'
        }].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-800 text-sm font-bold" style={{
          textShadow: '0 1px 6px rgba(255,255,255,0.9)'
        }} data-id="element-102">
              <span data-id="element-103">{item.icon}</span> {item.text}
            </div>)}
        </div>
      </div>
    </section>;
}